import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const handleError = (error) => {
  console.error('Department Node API Error:', error);

  if (error.response?.status === 503) {
    return {
      success: false,
      error: 'Service temporarily unavailable'
    };
  }

  if (error.response?.status === 401) {
    return {
      success: false,
      error: 'Unauthorized - Invalid credentials'
    };
  }

  if (error.response?.status === 400) {
    return {
      success: false,
      error: error.response?.data?.message || 'Bad request - Invalid data provided'
    };
  }

  return {
    success: false,
    error: error.response?.data?.message || error.message || 'Operation failed'
  };
};

export const assignNodeToDepartments = async ({ nodeId, departmentIds, token }) => {
  try {
    const response = await axios.post(`${BASE_URL}/compute-v2/v2/department/node`, {
      node_id: nodeId,
      department_ids: departmentIds
    }, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
        'x-auth-user': token
      }
    });

    // Check if there are errors in the response data
    if (response.data?.errors && Object.keys(response.data.errors).length > 0) {
      const errorMessages = Object.values(response.data.errors);
      return {
        success: false,
        error: errorMessages.join('; '),
        data: response.data,
        status: response.status
      };
    }

    return {
      success: true,
      data: response.data,
      status: response.status,
      message: 'Node assigned to departments successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

export const assignAllDepartmentNodesToUser = async ({ departmentId, userId, isSudo, token }) => {
  try {
    const response = await axios.post(`${BASE_URL}/compute-v2/v2/department/${departmentId}/node`, {
      user_id: userId,
      is_sudo: isSudo
    }, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
        'x-auth-user': token
      }
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
      message: 'All department nodes assigned to user successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

export const removeNodeFromDepartment = async ({ nodeId, departmentId, token }) => {
  try {
    const response = await axios.delete(`${BASE_URL}/compute-v2/v2/department/${departmentId}/node/${nodeId}`, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'x-auth-user': token
      }
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
      message: 'Node removed from department successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

export const getDepartmentNodes = async ({ departmentId, token }) => {
  try {
    const response = await axios.get(`${BASE_URL}/compute-v2/v2/department/${departmentId}/node`, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'x-auth-user': token
      }
    });

    return {
      success: true,
      data: {
        nodeIds: response.data.node_ids || response.data.nodeIds || []
      },
      status: response.status,
      message: 'Department nodes retrieved successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

